import instance from "./instance";

const AgendaAPI = (params) => {
  return instance.get(`/agenda?${params}`);
};

export default AgendaAPI;
